<template>
  <Transition
    :enterActiveClass="$style.appearEnterActive"
    :leaveActiveClass="$style.appearLeaveActive"
    :enterFromClass="$style.appearEnterFrom"
    :leaveToClass="$style.appearLeaveTo"
  >
    <slot />
  </Transition>
</template>

<style lang="scss" module>
.appearEnterActive,
.appearLeaveActive {
  transition:
    opacity 0.2s ease-in-out,
    transform 0.2s ease-in-out;
}

.appearEnterFrom,
.appearLeaveTo {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
